import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "../store/index";
import Login from "../views/Login.vue";
import Preview from "../views/Preview.vue";
import AdvertiserIndex from "../views/Advertiser/Index.vue";
import AdvertiserNew from "../views/Advertiser/New.vue";
import AdvertiserEdit from "../views/Advertiser/Edit.vue";
import AdvertiserEditComplete from "../views/Advertiser/EditComplete.vue";
import AdvertiserEmail from "../views/Advertiser/Email.vue";
import AdvertiserEmailComplete from "../views/Advertiser/EmailComplete.vue";
import AdvertiserPassword from "../views/Advertiser/Password.vue";
import AdvertiserPasswordComplete from "../views/Advertiser/PasswordComplete.vue";
import AdvertiserContact from "../views/Advertiser/Contact.vue";
import AdvertiserContactComplete from "../views/Advertiser/ContactComplete.vue";
import AdvertiserCreated from "../views/Advertiser/Created.vue";
import AdvertiserAdvertisementsReport from "../views/Advertiser/Advertisements/Report.vue";
import AdvertiserAdvertisementsDetail from "../views/Advertiser/Advertisements/Detail.vue";
import AdvertiserAdvertisementsEdit from "../views/Advertiser/Advertisements/Edit.vue";
import AdvertiserAdvertisementsComplete from "../views/Advertiser/Advertisements/Complete.vue";
import AdvertiserAdvertisementsNew from "../views/Advertiser/Advertisements/New.vue";
import AdvertiserAdvertisementsPublishment from "../views/Advertiser/Advertisements/Publishment.vue";
import AdvertiserAdvertisementsPublishmentComplete from "../views/Advertiser/Advertisements/PublishmentComplete.vue";
import AdministratorIndex from "../views/Administrator/Index.vue";
import AdministratorAdvertisementsIndex from "../views/Administrator/Advertisements/Index.vue";
import AdministratorAdvertisementsReport from "../views/Administrator/Advertisements/Report.vue";
import AdministratorAdvertisementsDetail from "../views/Administrator/Advertisements/Detail.vue";
import AdministratorAdvertisementsEdit from "../views/Administrator/Advertisements/Edit.vue";
import AdministratorAdvertisementsComplete from "../views/Administrator/Advertisements/Complete.vue";
import AdministratorSalesIndex from "../views/Administrator/Sales/Index.vue";
import AdministratorAdvertisersIndex from "../views/Administrator/Advertisers/Index.vue";
import AdministratorAdvertisersDetail from "../views/Administrator/Advertisers/Detail.vue";
import AdministratorAdvertisersEdit from "../views/Administrator/Advertisers/Edit.vue";
import AdministratorAdvertisersComplete from "../views/Administrator/Advertisers/Complete.vue";
import AdministratorAreasIndex from "../views/Administrator/Areas/Index.vue";
import AdministratorAreasNew from "../views/Administrator/Areas/New.vue";
import AdministratorAreasEdit from "../views/Administrator/Areas/Edit.vue";
import AdministratorAreasComplete from "../views/Administrator/Areas/Complete.vue";
import AdministratorCoursesIndex from "../views/Administrator/Courses/Index.vue";
import AdministratorCoursesNew from "../views/Administrator/Courses/New.vue";
import AdministratorCoursesEdit from "../views/Administrator/Courses/Edit.vue";
import AdministratorCoursesComplete from "../views/Administrator/Courses/Complete.vue";
import AdministratorAdReportIndex from "../views/Administrator/AdReport/Index.vue";
import TrialIndex from "../views/Trial/Index.vue";
import TrialComplete from "../views/Trial/Complete.vue";
import TrialError from "../views/Trial/Error.vue";

import Api from "@/api/Api";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  //   meta: { isPublic: true }
  // },
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: { isPublic: true }
  },
  {
    path: "/preview/:id/:token",
    component: Preview,
    meta: { isPublic: true }
  },
  {
    path: "/advertiser",
    name: "AdvertiserIndex",
    component: AdvertiserIndex,
    meta: {
      roles: ["ROLE_ADVERTISER"]
    }
  },
  {
    path: "/advertiser/contact",
    name: "AdvertiserContact",
    component: AdvertiserContact,
    meta: {
      roles: ["ROLE_ADVERTISER"]
    }
  },
  {
    path: "/advertiser/contact/complete",
    name: "AdvertiserContactComplete",
    component: AdvertiserContactComplete,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/new",
    name: "AdvertiserNew",
    component: AdvertiserNew,
    meta: { isPublic: true }
  },
  {
    path: "/advertiser/edit",
    name: "AdvertiserEdit",
    component: AdvertiserEdit,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/edit/complete",
    name: "AdvertiserEditComplete",
    component: AdvertiserEditComplete,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/email",
    name: "AdvertiserEmail",
    component: AdvertiserEmail,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/email/complete",
    name: "AdvertiserEmailComplete",
    component: AdvertiserEmailComplete,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/password",
    name: "AdvertiserPassword",
    component: AdvertiserPassword,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/password/complete",
    name: "AdvertiserPasswordComplete",
    component: AdvertiserPasswordComplete,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/created",
    name: "AdvertiserCreated",
    component: AdvertiserCreated,
    meta: { isPublic: true }
  },
  {
    path: "/advertiser/advertisements/new",
    name: "AdvertiserAdvertisementsNew",
    component: AdvertiserAdvertisementsNew,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/advertisements/:id",
    name: "AdvertiserAdvertisementsDetail",
    component: AdvertiserAdvertisementsDetail,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/advertisements/:id/report",
    name: "AdvertiserAdvertisementsReport",
    component: AdvertiserAdvertisementsReport,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/advertisements/:id/edit",
    name: "AdvertiserAdvertisementsEdit",
    component: AdvertiserAdvertisementsEdit,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/advertisements/:id/edit/complete",
    name: "AdvertiserAdvertisementsComplete",
    component: AdvertiserAdvertisementsComplete,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/advertisements/:id/publishment",
    name: "AdvertiserAdvertisementsPublishment",
    component: AdvertiserAdvertisementsPublishment,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/advertiser/advertisements/:id/publishment/complete",
    name: "AdvertiserAdvertisementsPublishmentComplete",
    component: AdvertiserAdvertisementsPublishmentComplete,
    meta: { roles: ["ROLE_ADVERTISER"] }
  },
  {
    path: "/administrator",
    name: "AdministratorIndex",
    component: AdministratorIndex,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/advertisements",
    name: "AdministratorAdvertisementsIndex",
    component: AdministratorAdvertisementsIndex,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/advertisements/:id/report",
    name: "AdministratorAdvertisementsReport",
    component: AdministratorAdvertisementsReport,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/advertisements/:id/detail",
    name: "AdministratorAdvertisementsDetail",
    component: AdministratorAdvertisementsDetail,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/advertisements/:id/edit",
    name: "AdministratorAdvertisementsEdit",
    component: AdministratorAdvertisementsEdit,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/advertisements/:id/edit/complete",
    name: "AdministratorAdvertisementsComplete",
    component: AdministratorAdvertisementsComplete,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/sales",
    name: "AdministratorSalesIndex",
    component: AdministratorSalesIndex,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/advertisers/:id",
    name: "AdministratorAdvertisersDetail",
    component: AdministratorAdvertisersDetail,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/advertisers/:id/edit",
    name: "AdministratorAdvertisersEdit",
    component: AdministratorAdvertisersEdit,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/advertisers/:id/complete",
    name: "AdministratorAdvertisersComplete",
    component: AdministratorAdvertisersComplete,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/advertisers",
    name: "AdministratorAdvertisersIndex",
    component: AdministratorAdvertisersIndex,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/areas",
    name: "AdministratorAreasIndex",
    component: AdministratorAreasIndex,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/areas/new",
    name: "AdministratorAreasNew",
    component: AdministratorAreasNew,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/areas/:id/edit",
    name: "AdministratorAreasEdit",
    component: AdministratorAreasEdit,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/areas/:id/edit/complete",
    name: "AdministratorAreasComplete",
    component: AdministratorAreasComplete,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/courses",
    name: "AdministratorCoursesIndex",
    component: AdministratorCoursesIndex,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/courses/new",
    name: "AdministratorCoursesNew",
    component: AdministratorCoursesNew,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/courses/:id/edit",
    name: "AdministratorCoursesEdit",
    component: AdministratorCoursesEdit,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/courses/:id/edit/complete",
    name: "AdministratorCoursesComplete",
    component: AdministratorCoursesComplete,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/administrator/ad_report/",
    name: "AdministratorAdReportIndex",
    component: AdministratorAdReportIndex,
    meta: { roles: ["ROLE_ADMINISTRATOR"] }
  },
  {
    path: "/trial/",
    name: "TrialIndex",
    component: TrialIndex,
    meta: { layout: "full-page", isPublic: true }
  },
  {
    path: "/trial/error/",
    name: "TrialError",
    component: TrialError,
    meta: { layout: "full-page", isPublic: true }
  },
  {
    path: "/trial/complete/",
    name: "TrialComplete",
    component: TrialComplete,
    meta: { layout: "full-page", isPublic: true }
  }
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => {
    return { x: 0, y: 0 };
  }
});

const api = Api.singleton();
router.beforeEach(async (to, from, next) => {
  const isRoutePublic = to.meta.isPublic || false;
  if (isRoutePublic) {
    next();
    return;
  }
  const roles = to.meta.roles || (isRoutePublic ? [] : ["ROLE_PSEUDO_GUARD"]);
  await api.jwtToken.tryLoadJwtToken();
  if (!api.jwtToken.isGranted(roles)) {
    next({ name: "Login" });
    return;
  }
  next();
});
export default router;
